
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 733"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"stroke fill-bg",attrs:{"d":"M142.83 525.67h129.5l42 86h-129l-42.5-86z"}}),_c('path',{staticClass:"stroke fill-bg",attrs:{"d":"M314.33 611.67l24.67-19h-33.95l9.28 19z"}}),_c('path',{staticClass:"fill",attrs:{"d":"M234.85 562.55c-7.55-6.27-9.11 2-9.11 2s-8.17-8.31-10.73-2 17.63 19.36 17.63 19.36 9.76-13.1 2.21-19.36z"}})])
          )
        }
      }
    